<div class="upload-progress-card">
  <h3 class="upload-progress-card-title">{{ 'localImport.fileStatus.progressBarTitle' | translate }}</h3>
  <div class="upload-progress-card-info">
    <span>{{ 'localImport.fileStatus.filesUploaded' | translate | interpolate:completedFiles:filesInfo.length }}</span>
    <div *ngIf="progressBarValue !== 0 && progressBarValue !== 100">
      <span class="separator">·</span>
      <span>{{ remainingTimeMessage }}</span>
    </div>
    <div *ngIf="failedFiles > 0">
      <span class="separator">·</span>
      <span class="errors">{{ 'common.labels.errors' | translate | interpolate:failedFiles }}</span>
    </div>
  </div>
  <div class="upload-progress-card-bar">
    <mat-progress-bar mode="determinate" [value]="progressBarValue" [color]="progressBarColor"></mat-progress-bar>
    <span>{{ progressBarValue }} %</span>
  </div>
</div>
